import React from "react";

function CameraOffIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      version="1.1"
      viewBox="327.929 1176.25 24 24"
      style={{ WebkitPrintColorAdjust: "exact", stroke:"none" }}
    >
      <g>
        <path
          fillRule="evenodd"
          d="M349.636 1178.371a1 1 0 00-1.415-1.414l-4.878 4.879a1.994 1.994 0 00-1.414-.586h-11a2 2 0 00-2 2v10a2 2 0 001.176 1.823l-1.47 1.47a1 1 0 101.415 1.414l19.586-19.586zm-17.708 14.879l10-10h-11v10h1z"
          clipRule="evenodd"
        ></path>
        <path
          fillRule="evenodd"
          d="M341.929 1193.25h-5.002l-2 2h7.002a2 2 0 002-2v-3l4.439 4.44c.945.944 2.56.275 2.56-1.061v-10.758c0-1.336-1.615-2.005-2.56-1.06l-4.44 4.439v-.002l-2 2v5.002zm2.828-5l4.172 4.172v-8.344l-4.172 4.172z"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
}

export default CameraOffIcon;